import { initAppListeners } from './listenerMiddleware';
import makeStore, { startAppListening } from './store';

export { useStateSelector, useStateDispatch } from './store';
export type {
  RootState,
  AppDispatch,
  StoreType,
  StartAppListeningFunction,
} from './store';

const store = makeStore(initAppListeners(startAppListening));

export default store;
